import React, { Component, Fragment } from 'react';
import { I18n } from 'react-redux-i18n-lite';
import PropTypes from 'prop-types';
import { capitalize } from '../../../utils/stringUtils';

import { DISCUSSION_MESSAGES_ORDER_OBJECT } from '../../../const';
import MessageItem from './MessageItem';
import { bindActionCreators } from 'redux';
import * as discussionActions from '../../../actions/discussionActions';
import { connect } from 'react-redux';
import CircularProgress from '@material-ui/core/CircularProgress';
import CustomSelect from '../../common/customSelect/CustomSelect';
import DeletedMessage from './DeletedMessage';

class DiscussionMessagesList extends Component {
  static defaultProps = {
    messages: []
  };

  state = {
    open: undefined
  };

  static propTypes = {
    messages: PropTypes.array.isRequired,
    messagesOrder: PropTypes.object,
    classroom: PropTypes.object,
    pages: PropTypes.number,
    currentPage: PropTypes.number,
    fetchingMessages: PropTypes.bool,
    discussionId: PropTypes.string,
    discussionActions: PropTypes.object,
    disableReplies: PropTypes.bool
  };

  componentWillUnmount() {
    const { discussionActions } = this.props;
    discussionActions.setSelectedDiscussionMessagesCurrentPage();
    discussionActions.setSelectedDiscussionMessagesPages();
    discussionActions.setSelectedDiscussionMessages();
  }

  toggleOpenMenu = () => {
    const { open } = this.state;
    this.setState({ open: !open });
  };

  closeMenu = () => {
    this.setState({ open: false });
  };

  getMoreDiscussions = async () => {
    const { discussionActions, discussionId, currentPage } = this.props;

    await discussionActions.setSelectedDiscussionMessagesCurrentPage(currentPage + 1);
    await discussionActions.getDiscussionMessages(discussionId);
  };

  renderMoreMessagesButton = () => {
    const { pages, currentPage, fetchingMessages } = this.props;

    if (currentPage < pages - 1) {
      if (fetchingMessages) {
        return (
          <div className="loading-posts">
            <CircularProgress />
          </div>
        );
      }
      return (
        <div className="more-discussions-button clickable-action" onClick={this.getMoreDiscussions}>
          {I18n.t('discussions.common.getMoreDiscussions')}
        </div>
      );
    }
  };

  getOptions = () => {
    return Object.keys(DISCUSSION_MESSAGES_ORDER_OBJECT).map(key => {
      if (DISCUSSION_MESSAGES_ORDER_OBJECT.hasOwnProperty(key)) {
        const option = DISCUSSION_MESSAGES_ORDER_OBJECT[key];
        option.name = capitalize(I18n.t(option.name));
        return option;
      }
    });
  };

  handleClickMenuItem = option => {
    const { discussionActions, messagesOrder } = this.props;
    if (messagesOrder.id !== option.id) {
      discussionActions.updateMessagesOrder(option);
    }
  };

  render() {
    const { messages, messagesOrder, discussionId, classroom, disableReplies } = this.props;
    const { open } = this.state;

    return (
      <Fragment>
        <div className="dropdown-container">
          <div className="dropdown-header" ref={node => (this.buttonRef = node)} onClick={this.toggleOpenMenu}>
            {messagesOrder ? capitalize(I18n.t(messagesOrder.name)) : ''}
            <i className={'custom-icons-triangle-arrow-icon'}></i>
          </div>
          <CustomSelect
            open={open}
            showCheckedIcon
            buttonRef={this.buttonRef}
            options={this.getOptions()}
            handleCloseSelect={this.closeMenu}
            handleClickMenuItem={this.handleClickMenuItem}
            selectedItem={messagesOrder}
          />
        </div>
        <div className="discussion-posts-container">
          {messages.map(message =>
            message.deleted ? (
              <DeletedMessage key={message.id} />
            ) : (
              <MessageItem
                classroom={classroom}
                discussionId={discussionId}
                disableReplies={disableReplies}
                key={message.id}
                replies={message.replies}
                message={message}
              />
            )
          )}
        </div>
        {this.renderMoreMessagesButton()}
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    messagesOrder: state.discussions.selectedDiscussion.messages.messagesOrder,
    fetchingMessages: state.discussions.selectedDiscussion.messages.fetching,
    pages: state.discussions.selectedDiscussion.messages.pages,
    currentPage: state.discussions.selectedDiscussion.messages.currentPage,
    classroom: state.classrooms.selectedClassroom.classroom
  };
}

function mapDispatchToProps(dispatch) {
  return {
    discussionActions: bindActionCreators(discussionActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DiscussionMessagesList);
